import { fetchAllCountries } from 'store/actions/countryActions';

import { configAxios } from 'services/apiConfig';
import { createLog } from 'services/logService';

export const fetchCountries = async (dispatch) => {
  try {
    const response = await configAxios.get('countries');

    fetchAllCountries(dispatch, response.data);

    return response.data;
  } catch (error) {
    return createLog(error);
  }
};

export const getCountries = async () => {
  try {
    const response = await configAxios.get('countries');

    return response.data;
  } catch (error) {
    return createLog(error);
  }
};
